import Vuex from 'vuex'

import { authentication } from '@/store/modules/authentication/authentication';
import { alert } from '@/store/modules/alert';
import { handleData } from '@/store/modules/handleData';
import { header } from '@/store/modules/header';
import { validate } from '@/store/modules/validate';

import { tinhTPDM } from './modules/danhmuc/tinhTp';
import { quanHuyenDM } from './modules/danhmuc/quanHuyen';

import { chucDanh } from './modules/danhmuc/chucDanh';
import { capDonVi } from './modules/danhmuc/capDonVi';

import { phanHeQT } from './modules/quantri/phanHe';
import { nhomQuyenQT } from './modules/quantri/nhomQuyen';
import { quyenQT } from './modules/quantri/quyen';
import { nguoiDungQT } from './modules/quantri/nguoiDung';
import { lichSuDangNhapQT } from './modules/quantri/lichSuDangNhap';
import { thongKeLichSuDangNhapQT } from './modules/quantri/thongKeLichSuDangNhap';

import { phuongXaDM } from './modules/danhmuc/phuongXa';
import { khomApDM } from './modules/danhmuc/khomAp';
import { toDanPhoDM } from './modules/danhmuc/toDanPho';
import { duongPhoDM } from './modules/danhmuc/duongPho';
import { donViQT } from './modules/quantri/donVi';

import { menuDanhSach } from './modules/menu/menu'





const debug = process.env.NODE_ENV !== 'production'
export const store = new Vuex.Store({
	modules: {
		authentication,
		alert,
		header,
		handleData,
		validate,
		menuDanhSach,
		tinhTPDM, quanHuyenDM, phuongXaDM, khomApDM, toDanPhoDM, duongPhoDM,
		chucDanh, capDonVi,
		phanHeQT, nhomQuyenQT, quyenQT, nguoiDungQT, donViQT, lichSuDangNhapQT, thongKeLichSuDangNhapQT,
	},
	strict: debug
});
